import Commons from "../../../Services/Common/Common";

export const WOR_BASIC_03_Schema = {
  fields: {
    resultContent: { initial: '', label: '조치 결과', required: 'Y' },
    resultDate: { initial: '', label: '조치일', required: 'Y' },
  },

  mapper: {
    save1: {
      NearMissSeq: (row) => row.nearMissSeq || null,
      ResultContent: (row) => Commons.EncryptAES(row.resultContent || ''),
      ResultDate: (row) => Commons.EncryptAES(row.resultDate || ''),
      ManagerId: (context) => context.userInfo?.userid ?? '',
      UserId: (context) => context.userInfo?.userid ?? '',
      Images: (row) => row.images || [],
    },
  },
};
